import React, { useEffect } from "react";
import DashboardStyle from "../../../../dashboard/Styles/Dashboard.module.css";
import PageLayout from "../../../Components/Layout/PageLayout";
import { FormTemplate } from "../../../Components/Forms/InputTemplate";
import { FormProvider, useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router";
import { GetSingleApplication } from "../../../../../utils/redux/HR/HRSlice";
import { FormatDateTime } from "../../../../../utils/functions/ResourceFunctions";

function JobListingDetails() {
 
  const dispatch = useDispatch();
  const getRequest = useSelector((state) => state?.hr);
  const { get_singleapplication, isLoading } = getRequest;
  const request = get_singleapplication?.responseObject;

  const { id } = useParams();
  useEffect(() => {
    dispatch(GetSingleApplication(id));
  }, [id]);

  return (
    <PageLayout title={"Application Channel Details"} hasBack={true}>
      <FormProvider>
        <FormTemplate
          className={DashboardStyle.view_app_components}
         
        >
          {/* Process Information Section */}
          <section
            style={{
              backgroundColor: "#F8FBF8",
              border: "1px solid #D9E9DA",
              borderRadius: "8px",
            }}
            className={DashboardStyle.form_section}
          >
            <h4 className={DashboardStyle.form_section_title}>
              Process Information
            </h4>
            <div className={DashboardStyle.labels_group}>
              <div>
               
                
                <div>
                  <p>Initiator Name:</p>
                  <h4>{request?.initiatorName}</h4>
                </div>
                <div>
                  <p>Initiated Date:</p>
                  <h4>{FormatDateTime(request?.createdDate, "ll")}</h4>
                </div>
              </div>
              <div>
               
                <div>
                  <p>Updated Date:</p>
                  <h4>{FormatDateTime(request?.updatedDate, "ll")}</h4>
                </div>
              </div>
            </div>
          </section>

          {/* Job Responsibility Section */}
          <section
            style={{
              backgroundColor: "#F8FBF8",
              border: "1px solid #D9E9DA",
              borderRadius: "8px",
            }}
            className={DashboardStyle.form_section}
          >
            <h4 className={DashboardStyle.form_section_title}>
            Channel
            </h4>

            <div className={DashboardStyle.labels_group}>
              <div>
                <div>
                  <p>Channel:</p>
                 <h4>{request?.channel}</h4>
                </div>
              </div>
            </div>
          </section>
        </FormTemplate>
      </FormProvider>
    </PageLayout>
  );
}

export default JobListingDetails;
